import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import InfiniteScroll from 'react-infinite-scroller';

import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';

import { Tabs, Tab } from 'material-ui/Tabs';
import { ListItem } from 'material-ui/List';

import FloatingActionButton from 'material-ui/FloatingActionButton';

import SearchBox from '../../../components/SearchBox';
import PersonCard from '../../../components/PersonCard';

import YoungPersonAdd from '../components/YoungPersonAdd';
import {
  changeTab,
  clearSearch,
  searchYoungPeople,
} from '../YoungPersonActions';
import { icons } from '../../../theme';

class YoungPersonList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAdd: false,
    };
    this.doSearch = debounce(this.doSearch.bind(this), 800);
  }

  fetchMore() {
    const { count, start, tab, loading, dispatch, text } = this.props;
    if (!loading) {
      const newStart = start + count;
      dispatch(searchYoungPeople(text, newStart, count, tab));
    }
  }

  doSearch(val) {
    const { count, tab, loading, dispatch } = this.props;
    if (!loading) {
      dispatch(searchYoungPeople(val, 0, count, tab));
    }
  }

  handleTabOnActive(tab, val) {
    const { dispatch } = this.props;
    dispatch(changeTab(tab));
    const { count, loading } = this.props;
    if (!loading) {
      dispatch(searchYoungPeople(val, 0, count, tab, 'tabChanged'));
    }
  }

  handleSearchButtonOnClick(val) {
    this.doSearch(val);
  }

  handleSearchBoxOnChange(val) {
    this.doSearch(val);
  }

  handleClearButtonOnClick() {
    this.props.dispatch(clearSearch());
    this.doSearch(null);
  }

  render() {
    const { tab, search, start, youngPeople, hasMore, error } = this.props;
    const list = search.text ? search.result : youngPeople;
    let hint = '';
    // switch (location.pathname) {
    //   case '/young':
    //     hint = 'Search young people';
    //     break;
    //   default:
    //     hint = 'Search';
    // }
    if (tab === 5) {
      hint = 'Search external young people';
    } else if (tab === 4) {
      hint = 'Search family young people';
    } else if (tab === 3) {
      hint = 'Search community young people';
    } else if (tab === 2) {
      hint = 'Search kennerley young people';
    } else {
      hint = 'Search young people';
    }

    return (
      <div className="container">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Young People - HEART1869</title>
          <meta name="description" content="Kennerley HEART1869 Young People" />
        </Helmet>
        <div className="content">
          <div className="list-tabs" style={{ overflowY: 'scroll' }}>
            <Tabs
              style={{
                maxWidth: '900px',
                marginLeft: 'auto',
                marginRight: 'auto',
                paddingBottom: '5px',
              }}
              value={tab}
              onChange={index => {
                this.setState({ tab: index });
              }}
            >
              <Tab
                label="Active"
                value="open"
                onActive={() => {
                  this.handleTabOnActive('open', search.text);
                }}
              />
              <Tab
                label="Inactive"
                value="closed"
                onActive={() => {
                  this.handleTabOnActive('closed', search.text);
                }}
              />
              <Tab
                label="Kennerley"
                value={2}
                onActive={() => {
                  this.handleTabOnActive(2, search.text);
                }}
              />
              <Tab
                label="Community"
                value={3}
                onActive={() => {
                  this.handleTabOnActive(3, search.text);
                }}
              />
              <Tab
                label="FCP"
                value={4}
                onActive={() => {
                  this.handleTabOnActive(4, search.text);
                }}
              />
              <Tab
                label="External"
                value={5}
                onActive={() => {
                  this.handleTabOnActive(5, search.text);
                }}
              />
              <Tab
                label="All"
                value={1}
                onActive={() => {
                  this.handleTabOnActive(1, search.text);
                }}
              />
            </Tabs>
          </div>
          <div className="list-head">
            <SearchBox
              hintText={hint}
              searchText={search.text}
              onClickSearch={val => this.handleSearchButtonOnClick(val)}
              onChangeSearch={val => this.handleSearchBoxOnChange(val)}
              onClickClear={() => this.handleClearButtonOnClick()}
            />
          </div>
          <div className="list-body" style={{ height: '87.05%' }}>
            <InfiniteScroll
              className="list-section"
              useWindow={false}
              pageStart={start}
              loadMore={() => this.fetchMore(start)}
              hasMore={!error && hasMore}
              initialLoad
            >
              {!isEmpty(list) ? (
                list.map(c => <PersonCard person={c} rel="young" key={c._id} />)
              ) : (
                <ListItem disabled>
                  {error
                    ? 'An error occurred, please refresh the app.'
                    : 'No results.'}
                </ListItem>
              )}
            </InfiniteScroll>
          </div>
          <FloatingActionButton
            className="fab"
            onClick={() => this.setState({ showAdd: true })}
          >
            <icons.AddIcon />
          </FloatingActionButton>
          <YoungPersonAdd
            closeDialog={() => this.setState({ showAdd: false })}
            open={this.state.showAdd}
          />
        </div>
      </div>
    );
  }
}

YoungPersonList.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  tab: state.young.tab,
  search: state.young.search,
  start: state.young.info.start,
  count: state.young.info.count,
  hasMore: state.young.info.hasMore,
  loading: state.young.info.loading,
  youngPeople: state.young.list,
  error: state.young.info.error,
});

export default connect(mapStateToProps)(YoungPersonList);
